<template>
    <b-container class="mt-4" fluid>
        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fas fa-tag mr-2"></i>Definición de cookie
            </template>
            <p>
                Una <i>cookie</i> es un pequeño fichero de texto que se almacena en su navegador cuando visita casi
                cualquier página web.
                Su utilidad es que la web sea capaz de recordar su visita cuando vuelva a navegar por esa página.
                Las <i>cookies</i> suelen almacenar información de carácter técnico, preferencias personales,
                personalización de contenidos, estadísticas de uso,
                enlaces a redes sociales, acceso a cuentas de usuario, etc. El objetivo de la <i>cookie</i> es adaptar
                el contenido de la web a su perfil y necesidades,
                sin <i>cookies</i> los servicios ofrecidos por cualquier página se verían mermados notablemente. Si
                desea consultar más
                información sobre qué son las <i>cookies</i>,
                qué almacenan, cómo eliminarlas, desactivarlas, etc., le rogamos se dirija a
                <b-link class="text-secondary" :to="{'name': 'cookies-page' }">este enlace</b-link>
                .
            </p>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fas fa-tag mr-2"></i> Cookies utilizadas en este sitio web
            </template>
            <p>
                Siguiendo las directrices de la Agencia Española de Protección de Datos procedemos a detallar el uso de
                cookies
                que hace esta web con el fin de informarle con la máxima exactitud posible. Este sitio web utiliza las
                siguientes <b>cookies</b>:
            </p>
            <table class="table">
                <tr>
                    <th>Identificador</th>
                    <th>Tipo</th>
                    <th>Finalidad</th>
                </tr>
                <tr>
                    <td>sessionid</td>
                    <td>Cookie propia de sesi&oacute;n</td>
                    <td>Cookie estandar del sistema para controlar el mantenimiento de la sesión y confirmar que el
                        usuario ha accedido correctamente.
                    </td>
                </tr>
                <tr>
                    <td>csrftoken</td>
                    <td>Cookie Propia</td>
                    <td>Proporciona el identificador necesario para evitar problemas relacionados con el
                        <a href="https://es.wikipedia.org/wiki/Cross-site_request_forgery">CSRF</a> en el envio de
                        peticiones dinimacas de informaci&oacute;n
                    </td>
                </tr>
            </table>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fas fa-tag mr-2"></i>Desactivaci&oacute;n o eliminaci&oacute;n de cookies
            </template>
            <p>
                En cualquier momento podrá ejercer su derecho de desactivación o eliminación de <i>cookies</i> de este
                sitio web.
                Estas acciones se realizan de forma diferente en función del navegador que esté usando.
                <b-link class="text-secondary" :to="{'name': 'cookies-page'}">Aquí le dejamos una guía rápida</b-link>
                para los navegadores más populares en el apartado <i>Configuración de cookies para los navegadores más
                populares.</i>
            </p>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fas fa-tag mr-2"></i>Notas adicionales
            </template>
            <ul>

                <li>Ni esta web ni sus representantes legales se hacen responsables ni del contenido ni de la veracidad
                    de las políticas de
                    privacidad que puedan tener los terceros mencionados en esta política de <i>cookies</i>.
                </li>
                <li>Los navegadores web son las herramientas encargadas de almacenar las <i>cookies</i> y desde este
                    lugar debe efectuar su derecho a
                    eliminación o desactivación de las mismas. Ni esta web ni sus representantes legales pueden
                    garantizar la correcta o
                    incorrecta manipulación de las <i>cookies</i> por parte de los mencionados navegadores.
                </li>
                <li>En algunos casos es necesario instalar cookies para que el navegador no olvide su decisión de no
                    aceptación de las mismas.
                </li>
                <li>Para cualquier duda o consulta acerca de esta política de <i>cookies</i> no dude en comunicarse con
                    nosotros a través de la sección de contacto.
                </li>
            </ul>
        </b-card>
    </b-container>
</template>

<script>
    export default {
        name: "CookiePolicyPage"
    };
</script>

<style scoped>

</style>